import React, { useEffect } from "react";

import { usePageTransition } from "../../services/hooks/usePageTransition";

import Survey from "../../components/Survey";

export default function Surveys() {
  const { startTransition, completeTransition } = usePageTransition();

  useEffect(() => {
    completeTransition();

    return () => {
      startTransition();
    };
  }, []);

  return <Survey />;
}
